var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"fixed pin-t pin-r block p-3 bg-white shadow-md z-10",staticStyle:{"left":"250px","height":"60px"}},[_c('div',{staticClass:"flex items-center w-full"},[_c('div',[_c('app-locales')],1),_vm._v(" "),_c('div',{staticClass:"ml-auto"},[_c('app-information',{attrs:{"opened":_vm.opened.information},on:{"open":_vm.open}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d9c24a5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/Header.vue
// module id = null
// module chunks = 